module.exports = __webpack_public_path__ + "static/media/i_love_you.5ad7a9f6.png";